import APIController from "./APIController"

const Offer = () => {
    //Requesthelper
    const { basicRequest, jsonRequest, getWorkspaceId } = APIController()

    const getAllOffers = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/offers/active`);
        return data;
    };

    const getOffer = async (offerCode) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/offers/${offerCode}`);
        return data;
    }

    const createOffers = async (count, offerDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/offers/create/${count}`, "POST", offerDTO);
        return data;
    };

    const disableOffers = async (offerCode) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/offers/delete/${offerCode}`, "DELETE");
        return data;
    }

    return {
        getAllOffers,
        getOffer,
        createOffers,
        disableOffers
    }
}

export default Offer